import { createStore } from 'stimulus-store'

/**
 * Store for all users in the organization
 * Used by the users supplier controller to share user data across components
 */
export const allUsersStore = createStore({
    name: 'allUsersStore',
    type: Array,
    initialValue: []
})
